// extracted by mini-css-extract-plugin
export default {"wrapper":"pay-amount-bar_wrapper__wqpZV","amount":"pay-amount-bar_amount__NNslV","icon":"pay-amount-bar_icon__lbZmI","iconClose":"pay-amount-bar_iconClose__iKo49"};